import { render } from "./reportOverview.vue?vue&type=template&id=513f1cdb&scoped=true"
import script from "./reportOverview.vue?vue&type=script&lang=js"
export * from "./reportOverview.vue?vue&type=script&lang=js"

import "./reportOverview.vue?vue&type=style&index=0&id=513f1cdb&lang=less&scoped=scoped"

import exportComponent from "E:\\claude_code\\healthmall\\tongue_desktop\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-513f1cdb"]])

export default __exports__